import { Maybe } from '@monetize/types/common';
import { MonetizeNowLogo } from '@monetize/ui/icons';
import { MBox, MFlex, MLink, MText } from '../../../../components/Monetize';

const SKIP_IF_REPLY_TO_DOMAIN = '@monetizenow.io';

interface CustomerPortalFooterProps {
  supportEmail?: Maybe<string>;
}

export const CustomerPortalFooter = ({
  supportEmail,
}: CustomerPortalFooterProps) => {
  return (
    <MFlex
      justifyContent="center"
      alignItems="center"
      py={6}
      mt="auto"
      bg="white"
    >
      <MFlex flexDirection="column" alignItems="center" gap={2}>
        {supportEmail &&
          !supportEmail.toLowerCase().endsWith(SKIP_IF_REPLY_TO_DOMAIN) && (
            <MText color="tGray.darkPurple" fontSize="sm" mr={2}>
              Contact{' '}
              <MLink
                href={`mailto:${supportEmail}`}
                color="tGray.darkPurple"
                fontWeight="bold"
              >
                {supportEmail}
              </MLink>{' '}
              with any questions.
            </MText>
          )}
        <MLink
          href="https://www.monetizenow.ai/"
          target="_blank"
          rel="noopener noreferrer"
          display="flex"
          alignItems="center"
          gap={2}
          _hover={{ textDecoration: 'none', opacity: 0.8 }}
          transition="opacity 0.2s"
        >
          <MText color="tGray.darkPurple" fontSize="sm">
            Powered by
          </MText>
          <MBox
            bg="tIndigo.base"
            borderRadius="md"
            p={1}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <MonetizeNowLogo width={16} height={16} />
          </MBox>
          <MText color="tIndigo.base" fontWeight="bold" fontSize="sm">
            MonetizeNow
          </MText>
        </MLink>
      </MFlex>
    </MFlex>
  );
};
